var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isConfigLoaded)?_c('ConfigLoader',{on:{"loadedConfiguration":function($event){_vm.isConfigLoaded = true}}}):_c('router-view',{staticClass:"view-home",attrs:{"id":"view-home"}})}
var staticRenderFns = []

export { render, staticRenderFns }